export const getURLParam = (url: string, param: string) => {
  const searchParams = new URLSearchParams(url);

  return searchParams.has(param) ? searchParams.get(param) : null;
};

export const parseLink = (text: string): { start: string; link: string; end: string } => {
  const splitText = text.split("[#link_start#]");
  const start = splitText.length ? splitText[0] : "";
  const end = splitText.length > 0 ? splitText[1].split("[#link_end#]")[1] : "";
  const link = splitText.length > 0 ? splitText[1].split("[#link_end#]")[0] : "";

  return {
    start,
    link,
    end,
  };
};
